import React, { useContext } from "react";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";
import { get } from "react-hook-form";

import { ErrorMessageProps } from "./ErrorMessage.props";
import styles from "./ErrorMessage.module.scss";
import { FormContext } from "../../Form/Form.context";

/**
 * @deprecated
 */
const ErrorMessage: React.FC<ErrorMessageProps> = ({ id, name, isLoading = false }: ErrorMessageProps): JSX.Element => {
  const { formState } = useContext(FormContext);
  const { errors } = formState;
  const errorMessageClasses = cn(styles["form-error-message"]);

  if (!isLoading) {
    return (
      <div id={`${id}-error-message`} className={errorMessageClasses} data-testid={`test__${id}-error-message`} role="alert">
        {get(errors, name).message}
      </div>
    );
  }
  return <Skeleton />;
};

/**
 * @deprecated
 */
export default ErrorMessage;
